<template>
    <hm-content>
        <div class="flex flex-end">
            <el-select
                    placeholder="请选择审核状态"
                    size="small"
                    class="mr10"
                    v-model="conditionQuery.value2"
                    clearable
            >
                <el-option
                        v-for="(v,i) in postStatus"
                        :label="v.label"
                        :value="v.value"
                        :key="i"
                ></el-option>
            </el-select>
            <el-date-picker
                    clearable
                    placeholder="请选择时间段"
                    size="small"
                    class="mr10"
                    v-model="conditionQuery.time"
                    type="datetimerange"
                    align="right"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['12:00:00', '08:00:00']">
            </el-date-picker>
            <el-input
                    clearable
                    size="small"
                    class="mr10"
                    placeholder="请输入订单号"
                    v-model="conditionQuery.goodsSn"
            ></el-input>
            <el-button
                    size="small"
                    class="mr10"
                    type="primary"
            >查询</el-button>
        </div>
        <div  class="mb20 flex-1" style="margin-top: 40px;">
            <el-table
                    highlight-current-row
                    :data="tableData"
                    :key="Math.random()"
                    size="small"
            >
                <el-table-column
                    type="index"
                    label="序号"
                    :index="index => index + (currentPage - 1) * pageSize + 1"
                    align="center"
                ></el-table-column>
                <el-table-column
                        label="状态"
                        prop=""
                        align="center"
                ></el-table-column>
                <el-table-column
                        label="提现单号"
                        prop=""
                        align="center"
                ></el-table-column>
                <el-table-column
                        label="公司名称"
                        prop=""
                        align="center"
                ></el-table-column>
                <el-table-column
                        label="支付宝收款账号"
                        prop=""
                        align="center"
                ></el-table-column>
                <el-table-column
                        label="电话号码"
                        prop=""
                        align="center"
                ></el-table-column>
                <el-table-column
                        label="身份证号"
                        prop=""
                        align="center"
                ></el-table-column>
                <el-table-column
                        label="申请时间"
                        prop=""
                        align="center"
                ></el-table-column>
                <el-table-column
                        label="申请金额"
                        prop=""
                        align="center"
                ></el-table-column>
                <el-table-column
                        label="审核时间"
                        prop=""
                        align="center"
                ></el-table-column>
                <el-table-column
                        label="审核人"
                        prop=""
                        align="center"
                ></el-table-column>
                <el-table-column
                        label="支付宝支付回执单号"
                        prop=""
                        align="center"
                ></el-table-column>
                <el-table-column
                        label="支付宝支付结果状态"
                        prop=""
                        align="center"
                ></el-table-column>
                <el-table-column
                        label="付款账号"
                        prop=""
                        align="center"
                ></el-table-column>
                <el-table-column
                        label="驳货原因"
                        prop=""
                        align="center"
                ></el-table-column>
                <el-table-column
                        label="操作"
                        prop=""
                        align="center"
                ></el-table-column>
            </el-table>
            <div class="hm-pagination">
                <el-pagination
                        background
                        :total="total"
                        @current-change="paging"
                        @size-change="handleSizeChange"
                        layout="total, sizes, prev, pager, next, jumper"
                        :current-page="currentPage"
                ></el-pagination>
            </div>
        </div>
    </hm-content>
</template>
<script>
    export default {
        data(){
            return{
                tableData:[],
                postStatus:[
                    {
                        label:'通过',
                        value:'yes'
                    },
                    {
                        label:'驳货',
                        value:'no'
                    },],//提现状态
                conditionQuery:{    //查询条件
                    value2:'',
                    time:'',
                    goodsSn:''
                },
                pageSize:10,
                currentPage:1,
                total:0,
            }
        },
        methods:{
            paging(page) {
                this.currentPage = page;
                this.queryPageList();
            },
            handleSizeChange(size) {
                this.currentPage = 1;
                this.pageSize = size;
                this.queryPageList();
            },
        }
    }
</script>
<style scoped lang="scss"></style>